import { DARK_MODE } from "./types";

export const darkModeActions = () => ({
    type: DARK_MODE,
});